import { IconNames } from '@blueprintjs/icons';
import { Icon } from '@strata/react-status-icons';
import classNames from 'classnames';
import { getIn, useFormikContext } from 'formik';
import PropTypes from 'prop-types';

export const CardControls = ({ arrayHelpers, index, onDeleteClick = undefined }) => {
    const formik = useFormikContext();

    const length = getIn(formik.values, arrayHelpers.name)?.length;
    const canMoveUp = index > 0;
    const canMoveDown = index + 1 < length;
    const canDelete = length > 1;

    return (
        <div className="sds_card-array__header-icons">
            <Icon
                icon={IconNames.DUPLICATE}
                onClick={() => {
                    arrayHelpers.insert(
                        index + 1,
                        getIn(formik.values, `${arrayHelpers.name}.${index}`),
                    );
                }}
                title="Duplicate"
            />
            <Icon
                className={classNames({
                    'sds_card-array__header-icons--disabled': !canDelete,
                })}
                icon={IconNames.TRASH}
                onClick={onDeleteClick}
                title="Delete"
            />
            <Icon
                className={classNames({
                    'sds_card-array__header-icons--disabled': !canMoveUp,
                })}
                icon={IconNames.CHEVRON_UP}
                onClick={() => arrayHelpers.swap(index, index - 1)}
                title="Move Up"
            />
            <Icon
                className={classNames({
                    'sds_card-array__header-icons--disabled': !canMoveDown,
                })}
                icon={IconNames.CHEVRON_DOWN}
                onClick={() => arrayHelpers.swap(index, index + 1)}
                title="Move Down"
            />
        </div>
    );
};

CardControls.propTypes = {
    arrayHelpers: PropTypes.shape({
        name: PropTypes.string.isRequired,
        swap: PropTypes.func.isRequired,
        insert: PropTypes.func.isRequired,
    }).isRequired,
    index: PropTypes.number.isRequired,
    onDeleteClick: PropTypes.func,
};
